import { Component, OnInit, OnDestroy } from '@angular/core';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit,OnDestroy {
  
  loading:boolean;
  subscription;
  constructor(private sharedService: SharedService) { }

  ngOnInit() {
    this.subscription = this.sharedService.isloading()
      .subscribe((isloading)=>{
          this.loading = isloading
      })
  }

  ngOnDestroy() {
      this.subscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/loader/loader.component.ts